import React, { useEffect, useState } from "react";
import { ActionSuccessDialog } from "./dashboard/ActionSuccessDialog";

// Claude Design (16) CMP Dashboard navLeaveSave / navSaved: after "Save &
// Update" in the UNSAVED CHANGES pop-up saves and the user moves on, the
// saved confirmation shows on the page they went to. The host lives in the
// dashboard Layout, so it stays mounted while the form page unmounts.

export const DEFAULT_SAVED_CHANGES_MESSAGE = "Your changes have been saved.";

export type SavedChangesNotice = Readonly<{ highlights?: readonly string[]; message: string }>;

const listeners = new Set<(notice: SavedChangesNotice) => void>();

export const announceSavedChanges = (notice: SavedChangesNotice): void => {
  listeners.forEach((listener) => listener(notice));
};

export const SavedChangesNoticeHost = (): React.ReactElement | null => {
  const [notice, setNotice] = useState<SavedChangesNotice | null>(null);
  useEffect(() => {
    listeners.add(setNotice);
    return () => {
      listeners.delete(setNotice);
    };
  }, []);
  if (!notice) return null;
  return (
    <ActionSuccessDialog
      message={notice.message}
      highlights={notice.highlights}
      onClose={() => setNotice(null)}
    />
  );
};
